<markant-popover
  id="user-menu-popover"
  data-cy="user-menu-popover"
  class="user-menu-popover"
  placement="bottom-start"
  distance="25"
  for="open-user-popover-btn"
  [visible]="showPopover"
  (backdrop)="closePopover()"
>
  <div class="popover-content">
    <ng-container *ngIf="organizationMemberships$ | async as organizations">
      <div
        *ngIf="
          organizations.length! > 1 ||
          (showOrganizationChangeForSingleOrganizationMembership &&
            organizations.length! > 0)
        "
        class="list-section"
      >
        <p class="list-header">
          {{ 'userMenu.organizationChange' | transloco }}
        </p>

        <ng-container *ngFor="let organization of organizations">
          <div
            class="organization-list-wrapper"
            [class.enabled]="
              organization.organizationId !== currentActiveOrganizationId
            "
            (click)="changeOrganization(organization.organizationId)"
            data-markant-close
          >
            <markant-icon
              slot="markant-list-item-leading"
              class="organization-list-item__icon"
              [icon]="
                organization.organizationId === currentActiveOrganizationId
                  ? 'm_company'
                  : 'm_chevron-right--dense'
              "
            ></markant-icon>
            <span
              #element
              class="organization-list-name"
              [class.disabled]="
                organization.organizationId === currentActiveOrganizationId
              "
            >
              {{ organization.organizationName }}
            </span>
            <markant-tooltip
              *ngIf="element.scrollWidth > element.clientWidth"
              [label]="organization.organizationName"
              placement="left"
            ></markant-tooltip>
          </div>
        </ng-container>
      </div>
    </ng-container>
    <markant-list class="list-section">
      <ng-container *ngIf="organizationMemberships$ | async as organizations">
        <p
          class="list-header"
          *ngIf="
            organizations.length! > 1 ||
            (showOrganizationChangeForSingleOrganizationMembership &&
              organizations.length! > 0)
          "
        >
          {{ 'userMenu.settingsHeadline' | transloco }}
        </p>
      </ng-container>

      <ng-container *ngFor="let item of listItems">
        <markant-list-item
          *ngIf="item.routeLink; else nonRoutingElement"
          [text]="'userMenu.' + item.label | transloco"
          [routerLink]="[item.routeLink]"
          data-markant-close
          (click)="clickItem(item)"
        >
        </markant-list-item>
        <ng-template #nonRoutingElement>
          <markant-list-item
            [text]="'userMenu.' + item.label | transloco"
            data-markant-close
            (click)="clickItem(item)"
          >
          </markant-list-item>
        </ng-template>
      </ng-container>
    </markant-list>

    <div class="user-menu-platform-version">
      {{ 'userMenu.version' | transloco }} {{ platformVersion }}
    </div>
  </div>
</markant-popover>

<markant-icon-button
  (click)="togglePopover()"
  id="open-user-popover-btn"
  data-cy="open-user-popover-btn"
  class="user-menu-button"
  icon="m_user"
  colorScheme="secondary"
  filled=""
>
</markant-icon-button>

<markant-list class="mobile-user-menu">
  <ng-container *ngFor="let item of listItems">
    <markant-list-item
      *ngIf="item.routeLink"
      class="list-item"
      [text]="'userMenu.' + item.label | transloco"
      [routerLink]="[item.routeLink]"
      [routerLinkActive]="['active']"
      data-markant-close
    >
    </markant-list-item>
  </ng-container>
  <ng-container *ngIf="organizationMemberships$ | async as organizations">
    <ng-container
      *ngIf="
        organizations.length > 1 ||
        (showOrganizationChangeForSingleOrganizationMembership &&
          organizations.length! > 0)
      "
    >
      <markant-list-item
        *ngFor="let organization of organizations"
        class="list-item"
        [class.disabled]="
          organization.organizationId === currentActiveOrganizationId
        "
        [text]="organization.organizationName"
        data-markant-close
        [disabled]="organization.organizationId === currentActiveOrganizationId"
        (click)="changeOrganization(organization.organizationId)"
      >
        <markant-icon
          slot="markant-list-item-leading"
          class="markant-list-item__icon"
          [icon]="
            organization.organizationId === currentActiveOrganizationId
              ? 'm_company'
              : 'm_chevron-right--dense'
          "
        ></markant-icon>
      </markant-list-item>
    </ng-container>
  </ng-container>
</markant-list>
